import { createFileRoute } from "@tanstack/react-router";
import { useApp } from "@/context/AppContext";
import { KundenAssistent } from "@/pages/client/KundenAssistent";
import { Assistant } from "@/pages/team/Assistant";

/**
 * Eine Adresse, zwei Sichten (wie `/projekte`): Das Team fragt über den
 * vollen Bestand, ein Kundenkonto nur über die eigenen Daten — die Grenze
 * hält das Backend (T083), hier wird nur die Seite gewählt.
 */
export const Route = createFileRoute("/_angemeldet/assistent")({
	component: AssistentSeite,
});

function AssistentSeite() {
	const { role } = useApp();
	return role === "mitarbeiter" ? <Assistant /> : <KundenAssistent />;
}
